<div class="loading" *ngIf="!games">
  <mtg-spinner></mtg-spinner>
</div>
<ng-container *ngIf="games && games.length > 0">
  <div class="title" *ngIf="!sliderTitle">Предстоящие игры {{ court && court.name }}</div>
  <div class="title" *ngIf="sliderTitle">{{ sliderTitle }}</div>
  <div class="tours" *ngIf="tours">
    <span>Показать:</span>
    <a href="javascript:;" (click)="setTour(null)" [ngClass]="{active: !currentTour}">Все</a>
    <a
      *ngFor="let tour of tours"
      href="javascript:;"
      (click)="setTour(tour)"
      [ngClass]="{active: tour === currentTour}"
    >
      {{ getTourTitle(tour) }}
    </a>
  </div>
  <div class="slider">
    <mtg-spinner *ngIf="!games"></mtg-spinner>
    <mtg-data-slider
      *ngIf="games"
      [arrowVisible]="true"
      [arrowInside]="false"
      #dataSliderComponent
    >
      <mtg-data-slider-item *ngFor="let game of games">
        <mtg-game-card
          [game]="game"
          [showTournament]="!tournamentId"
        ></mtg-game-card>
      </mtg-data-slider-item>
    </mtg-data-slider>
  </div>
</ng-container>
